<template>
  <div class="querty_content medicalRecordArea">
    <div>
      <div class="crumbs">
        <!-- <span><router-link :to="{name:'Transition'}">首页</router-link></span> > -->
        <span>首页</span>>
        <span>
          <router-link :to="{name:'MedicalRecord'}">典型病例库</router-link>
        </span> >
        <span>查看详情</span>
      </div>
      <div class="clearfix" style="width:100%">
        <div class="report_title">
          <b class="caseNmae" :title="detail.caseName">{{detail.caseName}}</b>
          <b>{{detail.caseSex}}</b>
          <b v-show="detail.caseAge !== undefined">{{detail.caseAge}}{{detail.ageUnit}}</b>
          <i v-for="(item, index) in detail.catalogList" :key="index">{{item.catalogname}}</i>
        </div>
        <div class="query_medicalRecord_left">
          <tabs @tabChange="tabChange" :activeName="'0'">
            <!--附件-->
            <el-tab-pane name="0" class="p-table-text">
              <span slot="label">附件({{attachList.length}})</span>
              <div class="list_title list_file_title">文件类型</div>
              <div class="query_medicalRecord_left_file_content">
                <div v-if="fileList.length === 0" class="defaultTxt">暂无上传文件</div>
                <div v-else>
                  <p
                    class="file_row"
                    :class="{active: index === fileI}"
                    v-for="(item, index) in fileList"
                    :key="index"
                    @click="fileCLick('file', item, index)"
                  >{{item.attach_name}}</p>
                </div>
              </div>
              <div class="list_title list_file_title">其他图片</div>
              <div class="query_medicalRecord_left_file_content">
                <div v-if="picList.length === 0" class="defaultTxt">暂无上传图片</div>
                <div v-else>
                  <p
                    class="file_row"
                    :class="{active: index === picI}"
                    v-for="(item, index) in picList"
                    :key="index"
                    @click="fileCLick('img', item, index)"
                  >{{item.attach_name}}</p>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane name="1" class="p-table-text">
              <span slot="label">影像({{studyList.length}})</span>
              <!--影像-->
              <div v-if="isImage === '1'">
                <div class="list_title">
                  <span style="width:30%;">检查编号</span>
                  <span style="width:10%;">性别</span>
                  <span style="width:10%;">年龄</span>
                  <span style="width:20%;">类型</span>
                  <span style="width:23%; text-align:left;">检查项目</span>
                </div>
                <div class="query_medicalRecord_left_image_content">
                  <div
                    v-if="detail.studyList.length === 0"
                    class="defaultTxt"
                    style="line-height:410px"
                  >暂无关联影像</div>
                  <div
                    v-for="(item, index) in detail.studyList"
                    :key="index"
                    class="list_cell"
                    :class="{check: index == this.i}"
                    v-if="reportShow"
                    @click="_getReportInfo(item, index)"
                  >
                    <span style="width:30%;">{{item.accessionNumber}}</span>
                    <span style="width:10%;">{{item.patientSex}}</span>
                    <span style="width:10%;" v-show="item.patientAge">{{item.patientAge}}</span>
                    <span style="width:20%;">{{item.examTypeName}}</span>
                    <span style="width:23%; text-align:left;">{{item.examBodyName}}</span>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </tabs>
        </div>
        <div class="query_medicalRecord_right">
          <div v-if="isImage === '1'" class="reportContent">
            <h2>
              {{reportInfo.examTypeName}}报告单
              <i class="btn btn2">电子病历</i>
              <i class="btn btn1" @click="getImage" v-show="readFilmY">阅片</i>
              <i class="btn4" v-show="readFilmN">阅片</i>
              <i class="btn btn3" @click="getReport">查看申请单</i>
            </h2>
            <report :info="reportInfo"></report>
          </div>
          <div class="file_area" v-else>
            <!-- <div v-if="this.detail.attachList.length===0" v-show="detailShow"> -->
            <div v-show="detailShow">
              <img width="100%" height="100%" src="../../../../static/image/defaultpic.png" alt>
              <p style="margin-top:23px; text-align:center">暂无内容</p>
            </div>
            <div v-if="imgShow=='1'" class="img_area">
              <img width="80%" :src="url" alt @click="showBigImg()">
            </div>
            <div v-if="imgShow=='0'" class="file_show">
              <p class="tip">暂不支持预览，请点击下载</p>
              <a :href="url">下载</a>
            </div>
            <!--<iframe v-else width="100%" height="100%" :src="url" frameborder="0"></iframe>-->
          </div>
        </div>
      </div>

      <div style="background: #fff; padding-bottom:20px;" class="text">
        <el-row style="padding-top: 20px;">
          <el-col :span="22">
            <h2 class="label_title_h2">
              <span></span>| 就诊信息
            </h2>
          </el-col>
        </el-row>
        <el-row style="padding-top: 25px;">
          <el-col :span="22">
            <div class>
              <span class="label_title">备注：</span>
              <span class="info_content">{{detail.remark}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row style="padding-top: 25px;">
          <el-col :span="22">
            <div class>
              <span class="label_title">患者病史：</span>
              <span class="info_content">{{detail.history}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row style="padding-top: 25px;">
          <el-col :span="22">
            <div class>
              <span class="label_title">病理结果：</span>
              <span class="info_content">{{detail.caseResult}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row style="padding-top: 25px;">
          <el-col :span="22">
            <div class>
              <span class="label_title">诊断所见：</span>
              <span class="info_content">{{detail.evidence}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row style="padding-top: 25px;">
          <el-col :span="22">
            <div class>
              <span class="label_title">诊断结果：</span>
              <span class="info_content">{{detail.dianogeResult}}</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 弹出申请单 -->
    <pops
      v-if="repShow"
      :show="repShow"
      @closePop="closePop"
      :width="popwidth"
      :title="title"
      :classes="'Collections'"
      class="collect"
    >
      <elcRep :elcRep="elcRep" :emergent="emergent"></elcRep>
    </pops>
    <!-- 弹出图片 -->
    <pops
      v-if="filePop"
      :show="filePop"
      :title="''"
      @closePop="closeFile"
      :class="'mrDialog'"
      :width="'980px'"
    >
      <img :src="url" width="100%" alt>
    </pops>
    <aycanImages
      ref="aycanImages"
      :hospitalId="params.hospitalId"
      :studyPk="params.studyPk"
      :studyUid="params.studyUid"
    ></aycanImages>
  </div>
</template>

<script>
import tabs from "@/components/common/tabs/tabs";
import report from "@/components/common/report/publicReport";
import http from "@/api/http";
import * as _ from "@/common/js/config";
import { nomalTime } from "@/common/js/time";
import elcRep from "@/components/common/report/electronicReport";
import pops from "@/components/common/pops/pop";
import aycanImages from "@/components/common/base/aycanImages";
import {
  changehosArea,
  changeAge,
  changeGender,
  changeSex,
  yinyang,
  changeclinicType
} from "@/common/js/change";

export default {
  components: {
    tabs,
    report,
    elcRep,
    pops,
    aycanImages
  },
  computed: {
    // ageUnit() {
    //   if (this.detail.ageUnit === '年') return '岁'
    // },
    // caseSex() {
    //   alert(this.detail,caseSex)
    //   return this.detail.caseSex
    //   // return _.SEXOBJ[this.detail.caseSex]
    // }
  },
  data() {
    return {
      params: {},
      popwidth: "80%",
      reportInfo: {},
      elcRep: {},
      repShow: false,
      emergent: false,
      readFilmY: false,
      readFilmN: true,
      filePop: false,
      detailShow: true,
      studyList: 0, //影像数量
      attachList: 0, //附件数量
      fileI: "",
      picI: "",
      fileList: [],
      picList: [],
      url: "",
      imgShow: "",
      isImage: "0",
      tabs: [
        {
          label: "附件",
          name: "0"
        },
        {
          label: "影像",
          name: "1"
        }
      ],
      detail: {
        caseName: "",
        studyList: []
      },
      check_applicat: {
        //查看申请单
        hospitalId: "",
        studyPk: 0,
        studyUid: ""
      },
      reportShow: true,
      title: ""
    };
  },
  methods: {
    showBigImg() {
      this.filePop = true;
    },
    tabChange(payload) {
      this.isImage = payload.name;
    },
    fileCLick(type, obj, index) {
      this.picI = "";
      this.fileI = "";
      let params = {
        refId: this.$route.params.id,
        businessType: "case"
      };
      http.post("system/getRelateAttachList.json", params).then(res => {
        if (res.data.code === _.ERR_OK) {
          if (obj.attach_type === "file") {
            this.fileI = index;
            for (let item of res.data.model) {
              if (item.fileid === obj.fileid) {
                //this.url = encodeURI(`https://ow365.cn/?i=15894&furl=${item.fileurl}`)
                this.url = encodeURI(encodeURI(item.fileurl));
                this.imgShow = "0";
                this.detailShow = false;
              }
            }
          } else {
            this.picI = index;
            this.detailShow = false;
            for (let item of res.data.model) {
              if (item.fileid === obj.fileid) {
                this.url = item.fileurl;
                this.imgShow = "1";
              }
            }
          }
          // alert(this.url)
        }
      });
    },
    _getCaseDetail(id) {
      http.post("/caselib/getCaseDetail.json", { id }).then(res => {
        if (res.data.code === _.ERR_OK) {
          this.studyList = res.data.model.studyList;
          this.detail = res.data.model;
          this.attachList = res.data.model.attachList;

          // console.log(this.detail)
          // console.log('************8')
          if (this.detail.ageUnit == "1") this.detail.ageUnit = "天";
          if (this.detail.ageUnit == "2") this.detail.ageUnit = "周";
          if (this.detail.ageUnit == "3") this.detail.ageUnit = "月";
          if (this.detail.ageUnit == "4") this.detail.ageUnit = "岁";
          if (this.detail.ageUnit == "5") this.detail.ageUnit = "小时";
          if (this.detail.caseSex == "1") {
            this.detail.caseSex = "男";
          } else {
            this.detail.caseSex = "女";
          }
          if (this.detail.attachList.length > 0) {
            for (let item of this.detail.attachList) {
              if (item.attach_type === "file") {
                this.fileList.push(item);
              } else {
                this.picList.push(item);
              }
            }
          }
        }
      });
    },

    closePop(val) {
      this.repShow = false;
    },
    closeFile(val) {
      this.filePop = false;
    },
    getImage() {
      this.$nextTick(() => {
        this.$refs.aycanImages.getConsultImages();
      });
      // let Aycan = this.params
      // http.post('/edu/prepareAycan.json', Aycan).then(res => {
      //   if (res.data.code === "0000") {
      //     let url = res.data.model
      //     window.open(url)
      //   }else{
      //     this.$message({
      //       message: "影像调阅失败",
      //       type: "error",
      //       duration: 1000
      //     });
      //   }
      // }).catch(() => {
      // })
    },
    _getReportInfo(item, index) {
      this.check_applicat = item;
      this.imageListI = index;
      this.readFilmY = true;
      this.readFilmN = false;
      this.reportInfo = {};
      this.elcRep = item;
      // this.check_applicat.hospitalId=item.hospitalId
      // console.log( this.check_applicat.hospitalId,' this.check_applicat.hospitalId')
      // this.check_applicat.studyUid=item.studyUid
      // this.check_applicat.studyPk=item.studyPk

      let param = {
        hospitalId: item.hospitalId,
        studyPk: item.studyPk + "",
        studyUid: item.studyUid
      };
      this.params = param;
      let aDiv = document.getElementsByClassName("list_cell");
      for (let item of aDiv) {
        item.style.background = "#fff";
        item.style.color = "#878e9e";
      }
      aDiv[index].style.background = "#e2e8f6";
      aDiv[index].style.color = "#333";
      if (item.reportState != 3) {
        this.$message({
          message: "该影像没有报告单",
          type: "error",
          duration: 1000
        });
        return false;
      }
      http.post("/edu/reportDetail.json", this.params).then(res => {
        if (res.data.code == "0000") {
          res.data.model.masculineFlag = yinyang(res.data.model.masculineFlag);
          res.data.model.patientSex = changeGender(res.data.model.patientSex);
          res.data.model.studiesDoneDt = nomalTime(
            res.data.model.studiesDoneDt
          );
          res.data.model.reportSdt = nomalTime(res.data.model.reportSdt);
          res.data.model.approveDt = nomalTime(res.data.model.approveDt);
          res.data.model.clinicType = changeclinicType(
            res.data.model.clinicType
          );
          if (res.data.model.patientAge == undefined) {
            res.data.model.patientAge = "";
          } else if (res.data.model.patientAge.indexOf("岁") > 0) {
            res.data.model.patientAge = res.data.model.patientAge;
          } else {
            res.data.model.patientAge =
              res.data.model.patientAge + changeAge(res.data.model.ageUnit);
          }
          this.reportInfo = res.data.model;
          sessionStorage.setItem("zerRep", JSON.stringify(this.reportInfo));
        } else {
          this.$message({
            message: "该条数据没有报告单",
            type: "error",
            duration: 1000
          });
        }
      });
    },
    getReport(item, index) {
      return;
    }
  },
  name: "query-medical-record-info",
  created() {
    this._getCaseDetail(this.$route.params.id);
  },
  watch: {
    "detail.studyList"() {
      for (let item of this.detail.studyList) {
        if (item.patientSex === "M") {
          item.patientSex = "男";
        } else {
          item.patientSex = "女";
        }
        if (item.patientAge === undefined) {
          item.patientAge = " ";
        } else if (item.patientAge.indexOf("岁") > 0) {
          item.patientAge = item.patientAge;
        } else {
          item.patientAge = item.patientAge + changeAge(item.ageUnit);
        }
      }
    }
  }
};
</script>

<style lang="stylus" type="text/stylus" scoped>
@import '~@/common/css/variable.styl';

.defaultTxt {
  line-height: 186px;
  text-align: center;
  width: 100%;
}

.querty_content {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.w98 {
  width: 98%;
  margin: 0 auto;
  padding-bottom: 20px;
}

.label_title {
  display: inline-block;
  width: 100px;
  text-align: right;
  float: left;
  color: #8a8f99;
}

.info_content {
  float: left;
  width: 80%;
  color: #333;
}

.query_medicalRecord_left {
  background: #fff;
  float: left;
  width: 30%;
  margin-bottom: 10px;
  height: 500px;
}

.query_medicalRecord_right {
  background: #fff;
  float: right;
  width: 69%;
  overflow: auto;
  margin-bottom: 10px;
  height: 500px;
}

.query_medicalRecord_left_content {
  height: 450px;
  overflow-y: height;
}

.query_detail {
}

.list_title {
  height: 36px;
  line-height: 36px;
  background: $color-maingrey;
  color: #fff;

  span {
    display: inline-block;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.list_cell {
  height: 36px;
  color: #878e9e;
  line-height: 36px;

  span {
    display: inline-block;
    text-align: center;
    width: 99%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.list_cell:hover {
  background: #f0f0f0;
}

.cell_dark {
  background: #7e8c8d;
}

.cell_light {
  background: #fff;
}

.query_medicalRecord_left_file_content {
  height: 186px;
  overflow-y: auto;
}

.list_file_title {
  text-indent: 14px;
}

.reportContent {
  h2 {
    font-size: 16px;
    color: #000;
    text-align: center;
    position: relative;
    line-height: 40px;
    height: 40px;
    font-weight: 900;

    .btn {
      position: absolute;
      width: 90px;
      text-align: center;
      height: 30px;
      line-height: 30px;
      top: 5px;
      font-size: 14px;
      right: 10px;
      cursor: pointer;
      border-radius: 4px;
      background: #00abad;
      color: #fff;
    }

    .btn4 {
      position: absolute;
      width: 90px;
      text-align: center;
      height: 30px;
      line-height: 30px;
      top: 5px;
      font-size: 14px;
      right: 10px;
      cursor: pointer;
      border-radius: 4px;
      background: #aaadb3;
      color: #fff;
    }

    .btn2 {
      background: #aaadb3;
      right: 110px !important;
    }

    .btn3 {
      background: #aaadb3;
      right: 210px !important;
    }
  }
}

.report_title {
  height: 50px;
  line-height: 50px;
  margin: 10px 0;
  background: #fff;
  color: #000;
  text-indent: 20px;
  font-size: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  b {
    font-weight: 900;
    margin-right: 10px;
  }

  i {
    font-style: normal;
    color: #ffffff;
    margin-right: 10px;
    padding: 2px 6px;
    background: #878e9e;
    border-radius: 4px;
    font-size: 13px;
  }

  span {
    margin-right: 10px;
  }
}

.label_title_h2 {
  font-weight: 900;
  text-indent: 20px;
  margin-top: -5px;
  color: #000;

  span {
    margin-right: 8px;
  }
}

.file_row {
  height: 36px;
  line-height: 36px;
  text-indent: 10px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file_row:hover {
  background: #f0f0f0;
}

.file_area {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.file_show a {
  display: block;
  width: 80px;
  height: 27px;
  line-height: 27px;
  cursor: pointer;
  background: #01abac;
  color: #fff;
  border-radius: 3px;
  text-align: center;
  margin: 10px auto 0;
}

.tip {
  text-align: center;
  font-size: 100%;
}

.img_area {
  max-width: 100%;
  max-height: 100%;
  text-align: center;

  img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }
}

.query_medicalRecord_left_image_content {
  height: 410px;
  overflow-y: auto;
}

.check {
  background: #f00;
}

.text {
  line-height: 1.5;
}

.active {
  color: #00abad;
}

.caseNmae {
  max-width: 300px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  float: left;
}

.report_title b {
  float: left;
}
</style>



// WEBPACK FOOTER //
// queryMedicalRecordInfo.vue?36ef2e4c